import data from '../data.json'

const venue = (state = data.venue, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default venue



// WEBPACK FOOTER //
// ./src/reducers/venue.js